import React from 'react';
import styled from 'styled-components/macro';
import ToTopImg from 'src/assets/images/toTop.svg';

const ToTopContorll = styled.img`
  position: fixed;
  right: 5%;
  bottom: 5%;
  width: 36px;
  height: 36px;
  cursor: pointer;
`;

/** 回到頂端功能鍵 */
const ToTop: React.FC = () => {
  return <ToTopContorll src={ToTopImg} onClick={() => window.scrollTo(0, 0)} alt="" />;
};

export default ToTop;
